<template>
	<div id="app">

		<transition name="fade" mode="out-in">
			<router-view :app="this" :pages="pages" />
		</transition>
		<gallery-view v-show="$store.state.gallery.length > 0" :images="$store.state.gallery" />

		<popup-stack-view :popups="$store.getters['pop/popups']" @pop="$store.dispatch('pop/pop')" @replace="(p, l) => { $store.dispatch('pop/replace', { popup: p, level: l }); }" @clear="$store.dispatch('pop/clear')" />
		<window-stack-view :windows="$store.getters['win/windows']" @pop="$store.dispatch('win/pop')" />
	</div>
</template>

<script>
	export default {
		props: ['langCode', 'pages'],
		components: {
		},
		methods: {
			greet: function () {
				console.log('Greetings all humans!!!');
			},
			created() {
				
			}
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		text-decoration: none;
		border: none;
		font-family: 'Montserrat', sans-serif;
		font-size: 16px;
		box-sizing: border-box;
		outline: none;

		-webkit-tap-highlight-color: transparent;

		-webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
	}

	input, textarea {
		-webkit-user-select: text; /* Safari */
     -khtml-user-select: text; /* Konqueror HTML */
       -moz-user-select: text; /* Firefox */
        -ms-user-select: text; /* Internet Explorer/Edge */
            user-select: text; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
	}

	html,body {
		margin: 0 0;
		height: 100%;
		width: 100%;
	}
	
	#app {
		width: 100%;
		height: 100%;
	}
	







	.fade-enter-active,
	.fade-leave-active {
		transition-duration: 0.3s;
		transition-property: opacity;
		transition-timing-function: ease; 
	}
	
	.fade-enter,
	.fade-leave-active {
		opacity: 0
	}



	sup {
		font-size: 12px;
	}
</style>